import tasks from '../tasks';

export default (config, flow) => {
  if (tasks.handleUserType(flow)) {
    tasks.redirectLoggedInUser();
  } else {
    tasks.initFlowConfig(config, flow.parsedNodes);
    tasks.startPPF(config, flow);
    tasks.trackVisit();
    tasks.trackPageview();
    tasks.trackNavbar();
    tasks.reportPerformance();
    tasks.trackClickedPixel();
    tasks.handleRouteChange();
  }
};
